/*
deletePresetModal.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { useTranslation } from "react-i18next"
import { is5inches } from "../../modules/util"

export interface DeletePresetModalProps {
    isOpen: boolean
    onCancel: () => void
    onDelete: () => void
    presetName: string
}

export default function DeletePresetModal (props: DeletePresetModalProps) {
  const { t } = useTranslation()
  const { isOpen, onCancel, onDelete, presetName } = props   
    return (
    <div
      className={`xrx-modal fade ${isOpen ? 'show' : ''}`}
      id='delete-preset-modal'
        tabIndex={-1}
        role='dialog'
        aria-labelledby='delete-preset-modal-label'
        aria-hidden={!isOpen}
        {...isOpen ? {style: {display: "block"}} : {}}
    >
      { isOpen &&
      <div className={`modal-dialog modal-dialog-centered px-0 ${is5inches ? "modal-sm" : "modal-md"}`} role='document'>
        <div className='modal-content'>
            <div className='modal-header xrx-header header-danger'>
                <div className='d-flex align-items-center'>
                    <div className='xrx-stacked-icon stacked-icon-size-32'>
                        <i className='xgl-danger_stack_bkgd xglsize-32'></i>
                        <i className='xgl-danger_stack_mdgd xglsize-32'></i>
                        <i className='xgl-danger_stack_frgd xglsize-32'></i>
                    </div>
                    <h5 className='modal-title ml-3 mt-1' id='delete-preset-modal-label'>{t('DELETE_PRESET')}</h5>
                </div>
            </div>
            <div className='modal-body' tabIndex={-1}>
                <span>{t('DELETE_PRESET_PROMPT')}</span>
                <br />
                <div className="mt-2 overflow-ellipsis pr-1"><span>{presetName}</span></div>
                <div className="d-flex flex-column w-100 pt-4">
                          <div className='row justify-content-end col-12 px-0 mx-0'>
        <div className='mr-3 d-flex align-items-center justify-content-center'>
          <button
            type='button'
            className='xrx-btn btn-glyph'
            onClick={onCancel}
          >
            <i className={`xgl-close xglsize-32 modal-button-icon`}></i>
            <span className={`btn-label modal-button-label`}>
              {t('CANCEL')}
            </span>
          </button>
        </div>
        <div className='d-flex align-items-center justify-content-center'>
          <button
            type='button'
            className={`xrx-btn btn-glyph btn-danger`}
            onClick={onDelete}
          >
            <i className={`xgl-trash xglsize-32 modal-button-icon`}></i>
            <span className='btn-label modal-button-label'>
              {t('DELETE')}
            </span>
          </button>
        </div>
      </div>
                </div>
            </div>
        </div>
        </div>
      }
    </div>
    )
}